import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { SimilarPost } from 'components/blog';

const Wrapper = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: 1rem 0;
  @media (max-width: ${props => props.theme.breakpoints.xxl}) {
    padding: 1rem;
  }
`;

const PostWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  margin-bottom: 1rem;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    grid-template-columns: auto;
  }
`;

const SimilarPosts = ({ posts }) => (
  <Fragment>
    {posts && posts.length > 0 &&
      <Wrapper>
        <h1>Related posts</h1>
        <PostWrapper>
          {posts.map((post, i) => (
            <SimilarPost key={i} post={post} />
          ))}
        </PostWrapper>
      </Wrapper>
    }
  </Fragment>
);

export default SimilarPosts;

SimilarPosts.propTypes = {
  posts: PropTypes.array.isRequired
};
